import { BankAccountInterface } from 'commons/types';

export default function bankAccountIsUnknown(
  bankAccount: BankAccountInterface,
): boolean {
  return bankAccount.holderName === 'unknown';
}
